export default __webpack_public_path__ + "static/media/lionLogo.e135fb1c.png";